import get from 'lodash/get';
import * as types from './constants';

const selectedPlotsInitialState = {
  all: [],
  valid: [],
  invalid: [],
};

const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  documents: [],
  property: {},
  applicationId: null,
  projectDetails: {
    projectCategory: 'SECONDARY',
    completionPercentage: 0,
    // primaryDeveloperId: 330,
    surveyor: {},
  },
  imageData: [],
  imageGallery: [],
  surveyor: {},

  selectedPlots: selectedPlotsInitialState,
  selectedPlotsType: null,
  plotsWithErrors: {},
  plots: {},
  developerProjects: [],
  surveyorsList: [],
  selectedPlotsNotification: null,
};

const transformPlotsData = (plots = []) => {
  return plots?.reduce((result, curPlot) => {
    const updatedResult = { ...result };
    if (curPlot?.errorCodes) {
      updatedResult.all = [curPlot, ...updatedResult?.all];
      updatedResult.invalid = [...updatedResult?.invalid, curPlot];
    } else {
      updatedResult.all = [...updatedResult?.all, curPlot];
      updatedResult.valid = [...updatedResult?.valid, curPlot];
    }

    return updatedResult;
  }, selectedPlotsInitialState);
};

export default function OffPlanProjectRegistrationReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.OFFPLAN_REGISTRATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.OFFPLAN_REGISTRATION_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        dataError: null,
      };

    case types.FETCH_APPLICATION_OFFPLAN_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        projectDetails: {
          ...state.projectDetails,
          ...action.payload?.projectDetails,
        },
        selectedPlotsType: get(action.payload, 'selectedPlotsType', null),
        surveyor: get(action.payload, 'surveyor', {}),
        imageGallery: get(action.payload, 'imageGallery', []),
        projectTypeIsPlot: action.payload?.projectDetails?.projectType === 'PLOT',
        surveyingConsultantDetails: {
          ...state.surveyingConsultantDetails,
          qaQcCheckCode: action.payload?.application?.qcCode,
        },
      };
    case types.FETCH_DOCUMENTS_OFFPLAN_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', []),
      };

    case types.INITIATE_OFFPLAN_REGISTRATION_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
      };

    case types.CHANGE_OFFPLAN_REGISTRATION_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };

    case types.DOWNLOAD_DOCUMENT_OFFPLAN_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.ADD_TO_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };

    case types.SAVE_APPLICATION_OFFPLAN_REGISTRATION_SUCCESS:
      const projectTypeIsPlot = action.payload?.projectType === 'PLOT';
      return {
        ...state,
        loading: false,
        // application: get(action.payload, 'application', {}),
        error: null,
        projectTypeIsPlot: state?.activeStep === 0 && projectTypeIsPlot,
      };

    case types.OFFPLAN_REGISTRATION_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }

    case types.CHECKOUT_OFFPLAN_REGISTRATION_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_OFFPLAN_REGISTRATION_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeStep: 0,
      };

    // post flow

    case types.APPROVAL_OFFPLAN_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case types.POST_RETURN_OFFPLAN_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case types.OFFPLAN_REGISTRATION_CLEAR_DATA:
      return defaultState;

    case types.DOWNLOAD_OFFPLAN_REGISTRATION_CONTRACT_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.UPLOAD_OFFPLAN_REGISTRATION_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
        inventorySheetError: false,
      };
    case types.UPDATE_PROJECT_DETAILS:
      return {
        ...state,
        projectDetails: { ...state.projectDetails, ...action.payload },
      };
    case types.UPDATE_SERVEYING_CONSULTANT_DETAILS:
      return {
        ...state,
        surveyingConsultantDetails: { ...state.surveyingConsultantDetails, ...action.payload },
      };
    case types.OFFPLAN_REGISTRATION_ADD_PLOTS_SUCCESS:
      const updatedSelectedPlotsType = get(action.payload, 'selectedPlotsType', null);
      const newManuallyAddedPlots = transformPlotsData(get(action.payload, 'selectedPlots', []));
      return {
        ...state,
        loading: false,
        activeStep: 1,
        selectedPlots: updatedSelectedPlotsType ? newManuallyAddedPlots : selectedPlotsInitialState,
        selectedPlotsType: updatedSelectedPlotsType,
        showPlotsNotification: get(action.payload, 'showPlotsNotification', false),
      };
    case types.OFFPLAN_REGISTRATION_UPLOAD_PLOTS_SUCCESS:
      const newUploadedPlots = transformPlotsData(get(action.payload, 'selectedPlots', []));
      return {
        ...state,
        loading: false,
        selectedPlots: newUploadedPlots,
        selectedPlotsType: get(action.payload, 'selectedPlotsType', null),
        showPlotsNotification: true,
      };
    case types.OFFPLAN_REGISTRATION_REMOVE_INVALID_PLOTS_SUCCESS:
      const newAddedPlots = transformPlotsData(get(action.payload, 'selectedPlots', []));
      return {
        ...state,
        loading: false,
        selectedPlots: newAddedPlots,
        selectedPlotsType: get(action.payload, 'selectedPlotsType', null),
        showPlotsNotification: true,
      };
    case types.OFFPLAN_REGISTRATION_FETCH_PLOTS_SUCCESS:
    case types.OFFPLAN_REGISTRATION_REMOVE_PLOTS_SUCCESS:
      const updatedSelectedPlots = transformPlotsData(get(action.payload, 'properties', []));
      return {
        ...state,
        loading: false,
        selectedPlots: updatedSelectedPlots,
      };
    case types.OFFPLAN_REGISTRATION_CLEAR_PLOTS_TYPE:
      return {
        ...state,
        selectedPlotsType: null,
      };
    case types.FETCH_DEVELOPERS_SUCCESS:
      return {
        ...state,
        developers: action.payload,
        loading: false,
      };
    case types.FETCH_DEVELOPER_PROJECTS_SUCCESS:
      return {
        ...state,
        developerProjects: action.payload,
        loading: false,
      };
    case types.FETCH_DEVELOPER_PROJECTS_FAILURE:
      return {
        ...state,
        developerProjects: [],
        loading: false,
        error: action.payload,
      };
    case types.FETCH_SURVEYORS_LIST_SUCCESS:
      return {
        ...state,
        surveyorsList: action.payload,
        loading: false,
      };
    case types.FETCH_SURVEYORS_LIST_FAILURE:
      return {
        ...state,
        surveyorsList: [],
        loading: false,
        error: action.payload,
      };
    case types.SET_SURVEYOR_SUCCESS:
      return {
        ...state,
        loading: false,
        surveyor: get(action.payload, 'surveyor', {}),
      };
    case types.SET_SURVEYOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_IMAGES_SUCCESS:
      return {
        ...state,
        imageData: action.payload,
        loading: false,
      };
    case types.FETCH_IMAGES_FAILURE:
      return {
        ...state,
        loading: false,
        imageData: [],
        error: action.payload,
      };
    case types.UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        imageData: action.payload,
        loading: false,
      };
    case types.UPLOAD_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.MARK_IMAGE_SUCCESS:
      return {
        ...state,
        imageData: action.payload,
        loading: false,
      };
    case types.MARK_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DELETE_IMAGE_SUCCESS:
      return {
        ...state,
        imageData: action.payload,
        loading: false,
      };
    case types.DELETE_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_PROPERTIES_INFORMATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_PROPERTIES_INFORMATION_SUCCESS:
      return {
        ...state,
        loading: false,
        propertiesInformation: get(action.payload, 'propertiesInformation', []),
      };
    case types.CLEAR_PLOTS_NOTIFICATION:
      return {
        ...state,
        showPlotsNotification: false,
      };
    case types.PROJECT_INVENTORY_SHEET_ERROR:
      return {
        ...state,
        showInventorySheetModal: true,
        inventorySheetError: true,
        loading: false,
      };
    case types.TOGGLE_INVENTORY_SHEET_MODAL:
      return {
        ...state,
        showInventorySheetModal: !state.showInventorySheetModal,
      };
    case types.TOGGLE_RETURN_MODAL:
      return {
        ...state,
        showModalReturn: !state.showModalReturn,
      };
    default:
      return state;
  }
}
